import "./bootstrap";
import { ConfigProvider } from "antd";

import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "react-query";
import { BrowserRouter } from "react-router-dom";
import App from "./App";

import ScrollToTop from "wrappers/ScrollToTop";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ScrollToTop>
          <ConfigProvider
            theme={{
              hashed: false,
              components: {
                Collapse: { headerBg: "none" },
              },
            }}>
            <App />
          </ConfigProvider>
        </ScrollToTop>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
